"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LevelEndAction = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@dp-instant/core");
var interfaces_1 = require("@dp-instant/interfaces");
var inversify_1 = require("inversify");
var SocialFlowAction_1 = require("./SocialFlowAction");
var LevelEndAction = (function (_super) {
    tslib_1.__extends(LevelEndAction, _super);
    function LevelEndAction() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.TRACK_EVENT = "level_end";
        return _this;
    }
    LevelEndAction.prototype.beforeLaunch = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._won = this.isWon();
                        this.tryToShowBanner();
                        return [4, Promise.all([this.submitScore(), this.showAdIfNeeded()])];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    LevelEndAction.prototype.launch = function () {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.sendPush(interfaces_1.TypesNotification.finish, { isWon: this._won });
                        return [4, ((_a = (0, core_1.lazyGet)(interfaces_1.TypesFlow.UI.endScreenAction)) === null || _a === void 0 ? void 0 : _a.run(this._won))];
                    case 1:
                        _b.sent();
                        return [2];
                }
            });
        });
    };
    LevelEndAction.prototype.submitScore = function () {
        var _a, _b, _c;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        this.social.postSessionScore();
                        (_a = this.leaderboardGlobal) === null || _a === void 0 ? void 0 : _a.submit(this.social.me.scoreSession).then();
                        if (this.social.me.scoreSession > this.social.me.scoreGlobal) {
                            (_b = (0, core_1.lazyGet)(interfaces_1.TypesFlow.share)) === null || _b === void 0 ? void 0 : _b.run();
                        }
                        if (!!this.social.inSolo) return [3, 2];
                        return [4, ((_c = this.leaderboardContext) === null || _c === void 0 ? void 0 : _c.submit(this.social.me.scoreSession))];
                    case 1:
                        _d.sent();
                        _d.label = 2;
                    case 2: return [2];
                }
            });
        });
    };
    LevelEndAction.prototype.needToShowAD = function () {
        return false;
    };
    LevelEndAction.prototype.isWon = function () {
        if (typeof this.data === "boolean") {
            return this.data;
        }
        if (this.social.inSolo) {
            return this.social.me.scoreSession > this.social.me.scoreGlobal;
        }
        if (this.social.inBlindContext) {
            return true;
        }
        if (this.social.inGroup) {
            var _a = tslib_1.__read(this.social.contextPlayers.sort(function (a, b) { return b.scoreContext - a.scoreContext; }), 1), winner = _a[0];
            if (winner) {
                return (Math.max(this.social.me.scoreContext, this.social.me.scoreSession) >=
                    winner.scoreContext);
            }
        }
        return !!(this.social.opponent && this.social.me.scoreSession > this.social.opponent.scoreContext);
    };
    Object.defineProperty(LevelEndAction.prototype, "leaderboardContext", {
        get: function () {
            return (0, core_1.lazyGet)(interfaces_1.TypesSocial.leaderboardContext);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LevelEndAction.prototype, "leaderboardGlobal", {
        get: function () {
            return (0, core_1.lazyGet)(interfaces_1.TypesSocial.leaderboardGlobal);
        },
        enumerable: false,
        configurable: true
    });
    LevelEndAction.prototype.track = function () {
        var _a;
        (_a = (0, core_1.lazyGet)(interfaces_1.TypesAnalytics.tracker)) === null || _a === void 0 ? void 0 : _a.track(this.TRACK_EVENT, 1, {
            status: this.isWon() ? "won" : "loose"
        });
    };
    LevelEndAction = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], LevelEndAction);
    return LevelEndAction;
}(SocialFlowAction_1.SocialFlowAction));
exports.LevelEndAction = LevelEndAction;
//# sourceMappingURL=LevelEndAction.js.map